var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _circle2, _circle3, _circle4, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 51,
    viewBox: "0 0 208 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8742 22.7106L48.4591 16.2344L39.6581 19.6801C39.6581 19.6801 39.9072 28.2735 38.3296 31.0965C37.956 32.4664 32.6837 40.3126 30.3174 40.3956C32.0195 39.7314 36.503 36.7839 38.3711 32.9231C40.2393 29.0623 40.779 24.2466 40.779 24.2466L48.8742 22.7106Z",
    fill: "url(#paint0_radial_3997_4413)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2236 38.4028C33.2236 38.4028 39.2432 34.625 39.1602 33.5872C40.6962 34.708 46.7988 37.9461 46.7988 37.9461C46.7988 37.9461 42.1077 42.9694 40.6547 43.7581C39.7414 42.8033 34.8842 37.7386 34.8842 37.7386L33.2236 38.4028Z",
    fill: "url(#paint1_radial_3997_4413)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3555 39.7313C31.3555 39.7313 38.1223 35.9535 39.8659 28.481C40.0735 27.3186 40.6131 24.0389 40.6131 24.0389L49.8293 22.5444C49.8293 22.5444 49.5802 27.7752 48.5423 30.2661C47.2139 30.1 40.9452 29.1452 40.9452 29.1452C40.9452 29.1452 37.5826 36.9499 31.3555 39.7313Z",
    fill: "#2771B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5557 38.6936C33.5557 38.6936 39.4922 33.1307 40.6961 28.8962C41.5679 28.9378 48.4593 30.3492 49.8707 30.1002C49.8707 30.7229 47.1723 36.8255 46.0514 37.6557C44.806 36.95 39.4922 33.8779 39.4922 33.8779L33.5557 38.6936Z",
    fill: "#E80980"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8759 18.1853C25.1702 18.1853 24.5474 17.8117 24.1738 17.2305C23.8417 16.6078 23.8417 15.902 24.2153 15.2793C24.5474 14.6566 25.2117 14.283 25.8759 14.283C26.5816 14.3245 27.2043 14.6981 27.5365 15.2793C27.8686 15.902 27.9101 16.6078 27.578 17.2305C27.2043 17.8117 26.5816 18.1853 25.8759 18.1853ZM24.589 16.9814C24.8796 17.438 25.3777 17.6871 25.8759 17.6871C26.4156 17.6871 26.8722 17.438 27.1628 16.9814C27.4119 16.5247 27.4119 15.9435 27.1213 15.4869C26.8722 15.0302 26.3741 14.7396 25.8344 14.7396C25.2947 14.7811 24.838 15.0302 24.5474 15.4869C24.3399 15.985 24.3399 16.5247 24.589 16.9814Z",
    fill: "url(#paint2_radial_3997_4413)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8759 17.8531C25.2947 17.8531 24.755 17.5625 24.4229 17.0643C24.1323 16.5662 24.1738 15.9435 24.4644 15.4038C24.755 14.9056 25.2947 14.5735 25.8759 14.5735C26.4571 14.5735 26.9968 14.9056 27.2874 15.4038C27.578 15.9019 27.578 16.5247 27.3289 17.0643C26.9968 17.5625 26.4571 17.8531 25.8759 17.8531Z",
    fill: "url(#paint3_radial_3997_4413)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M24.7961 16.8569C25.0452 17.2305 25.4603 17.4381 25.8754 17.4796C26.3321 17.4796 26.7472 17.2721 26.9548 16.8569C27.1624 16.4833 27.1624 15.9851 26.9133 15.6115C26.7057 15.2379 26.2906 14.9888 25.8339 14.9473C25.3773 14.9473 25.0036 15.1964 24.7546 15.6115C24.5885 16.0266 24.5885 16.4833 24.7961 16.8569Z",
    fill: "url(#paint4_radial_3997_4413)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8758 17.1059C25.5437 17.1059 25.2531 16.9398 25.0871 16.6908C24.921 16.4002 24.9625 16.068 25.0871 15.819C25.2531 15.5284 25.5437 15.3623 25.8343 15.3623C26.1664 15.3623 26.4155 15.5284 26.5816 15.819C26.7476 16.1096 26.7476 16.4417 26.5816 16.6908C26.4985 16.9398 26.2079 17.1059 25.8758 17.1059Z",
    fill: "url(#paint5_radial_3997_4413)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25.8763 16.7322C25.6688 16.7322 25.5027 16.6492 25.4197 16.4831C25.3367 16.3171 25.3367 16.1095 25.4197 15.9434C25.5027 15.7774 25.6688 15.6943 25.8763 15.6528C26.0839 15.6528 26.25 15.7774 26.333 15.9434C26.416 16.1095 26.416 16.3171 26.333 16.4831C26.25 16.6492 26.0839 16.7322 25.8763 16.7322Z",
    fill: "url(#paint6_radial_3997_4413)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5439 16.1095C25.4608 16.1095 25.4193 16.068 25.3778 16.0264C25.3363 15.9434 25.3363 15.9019 25.3778 15.8189C25.4193 15.7358 25.5024 15.6943 25.5439 15.6943C25.6269 15.6943 25.6684 15.7358 25.7099 15.8189C25.7514 15.9019 25.7514 15.9434 25.7099 16.0264C25.6684 16.068 25.6269 16.1095 25.5439 16.1095Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3029 10.7544C34.3029 10.7544 43.0624 10.5053 48.2516 25.7825C50.1613 34.0439 52.1125 39.8974 52.1125 39.8974C52.1125 39.8974 52.0709 43.343 60.0002 43.7997C56.5545 44.9206 35.9634 55.2161 34.635 36.9914C35.6728 37.5311 43.1454 43.343 45.3456 43.5506C43.9342 42.4297 31.5629 38.2368 34.2614 27.2771C35.2992 27.8167 42.1906 34.459 44.5569 35.0402C43.6851 34.1269 31.4384 27.2771 33.8462 18.6421C34.635 18.7251 40.8206 24.205 42.0245 24.5371C43.2284 24.8692 43.2284 24.8692 43.2284 24.8692C41.0282 23.9144 32.5178 18.0194 34.3029 10.7544Z",
    fill: "#E80980"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0791 40.6861L35.2989 37.448L41.6506 44.0903C41.6506 44.0903 35.5065 47.9926 33.5968 47.9096C32.7665 46.6641 30.2342 40.2294 30.2342 40.2294L27.0791 40.6861Z",
    fill: "#E80980"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1282 0.00222695V9.42595C25.1282 9.42595 16.8254 10.2562 14.21 14.2416C12.1343 16.4003 7.2356 22.3784 10.8473 31.8021C11.8437 33.3381 15.2478 40.354 24.7546 41.0598C26.7473 40.8107 30.2345 40.2295 30.2345 40.2295L33.9292 48.6984C33.9292 48.6984 14.9157 55.6313 4.12204 39.2331C2.71056 37.282 -2.18812 29.8509 1.13302 17.5627C2.46147 14.1586 8.10741 -0.205344 25.1282 0.00222695Z",
    fill: "url(#paint7_radial_3997_4413)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6467 41.348C34.7719 41.348 42.1693 33.9506 42.1693 24.8254C42.1693 15.7002 34.7719 8.30273 25.6467 8.30273C16.5215 8.30273 9.12402 15.7002 9.12402 24.8254C9.12402 33.9506 16.5215 41.348 25.6467 41.348Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4229 30.3906V21.216C24.4229 21.216 24.7135 19.0987 27.3288 19.4309C27.3288 20.0121 27.3288 30.4736 27.3288 30.4736L24.4229 30.3906Z",
    fill: "url(#paint8_radial_3997_4413)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6362 14.9451C28.6362 16.55 27.3351 17.8511 25.7302 17.8511C24.1253 17.8511 22.8242 16.55 22.8242 14.9451C22.8242 13.3401 24.1253 12.0391 25.7302 12.0391C27.3351 12.0391 28.6362 13.3401 28.6362 14.9451ZM23.4054 14.9451C23.4054 16.229 24.4463 17.2699 25.7302 17.2699C27.0142 17.2699 28.055 16.229 28.055 14.9451C28.055 13.6611 27.0142 12.6203 25.7302 12.6203C24.4463 12.6203 23.4054 13.6611 23.4054 14.9451Z",
    fill: "url(#paint9_radial_3997_4413)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.7301,
    cy: 14.9452,
    r: 2.3248,
    fill: "url(#paint10_radial_3997_4413)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.7305,
    cy: 14.9451,
    r: 1.54986,
    fill: "url(#paint11_radial_3997_4413)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.7304,
    cy: 14.945,
    r: 0.968665,
    fill: "#E80980"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9548,
    cy: 14.3638,
    r: 0.387466,
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2209 28.4265C81.2209 29.9793 79.9343 31.2659 78.3816 31.2659H78.3372L70.8838 22.9251V28.4265C70.8838 29.9793 69.5972 31.2659 68.0444 31.2659H68V21.6829C68 20.1301 69.2866 18.8435 70.8394 18.8435H70.8838L78.3372 27.1399V21.6829C78.3372 20.1301 79.6238 18.8435 81.1766 18.8435H81.2209V28.4265Z",
    fill: "url(#paint12_linear_3997_4413)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9961 21.6829C82.9961 20.1301 84.2827 18.8435 85.8355 18.8435H96.6607V18.8879C96.6607 20.4407 95.3741 21.7273 93.8213 21.7273C90.2277 21.7273 86.5897 21.7273 82.9961 21.7273V21.6829ZM85.9242 27.0068V28.3821H96.7051C96.7051 30.0236 95.4185 31.2659 93.8657 31.2659C90.2721 31.2659 86.6341 31.2659 83.0405 31.2659V26.4744C83.0405 24.9216 84.3271 23.635 85.8799 23.635C89.4735 23.635 93.1114 23.635 96.7051 23.635C96.7051 25.2765 95.4185 26.5187 93.8657 26.5187H86.4122C86.1461 26.5187 85.9242 26.7406 85.9242 27.0068Z",
    fill: "url(#paint13_linear_3997_4413)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.455 30.1568C111.656 30.911 110.724 31.2659 109.571 31.2659H102.251C101.141 31.2659 100.165 30.911 99.3668 30.1568C98.5682 29.4026 98.1689 28.4709 98.1689 27.3618V18.8879H98.2133C99.7661 18.8879 101.053 20.1745 101.053 21.7273V27.3618C101.053 28.0716 101.452 28.3822 102.206 28.3822H109.482C110.236 28.3822 110.636 28.0273 110.636 27.3618V21.7273C110.636 20.1745 111.922 18.8879 113.475 18.8879H113.519V27.3618C113.608 28.4709 113.253 29.4026 112.455 30.1568Z",
    fill: "url(#paint14_linear_3997_4413)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M125.898 18.8435C128.205 18.8435 130.068 20.7512 130.068 23.0582C130.068 25.3652 128.16 27.2286 125.898 27.2286H122.703L125.055 31.2659H121.727L117.734 24.3448H125.942C127.628 24.3448 127.628 21.7716 125.942 21.7716H117.867C116.803 21.7716 115.915 21.2392 115.383 20.3519L114.54 18.8879H125.898V18.8435Z",
    fill: "url(#paint15_linear_3997_4413)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M146.705 27.3617C146.705 29.6687 144.886 31.3102 142.623 31.3102H135.347C133.129 31.3102 131.266 29.6687 131.266 27.3617V22.792C131.266 20.485 133.085 18.8435 135.347 18.8435H142.623C144.842 18.8435 146.705 20.485 146.705 22.792V27.3617ZM143.777 22.792C143.777 22.0822 143.377 21.7716 142.623 21.7716H135.347C134.593 21.7716 134.194 22.1266 134.194 22.792V27.3617C134.194 28.0715 134.593 28.3821 135.347 28.3821H142.623C143.377 28.3821 143.777 28.0272 143.777 27.3617V22.792Z",
    fill: "url(#paint16_linear_3997_4413)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M169.705 28.5355L167.943 31.5769H159.672C158.04 31.5769 156.705 30.2231 156.705 28.5912V18.5769H156.761C158.393 18.5769 159.728 19.9307 159.728 21.5626V28.0163C159.728 28.2944 159.969 28.5355 160.247 28.5355H169.705Z",
    fill: "url(#paint17_linear_3997_4413)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M175.205 21.5626V31.5769H175.15C173.53 31.5769 172.205 30.2231 172.205 28.5912V18.5769H172.26C173.88 18.5769 175.205 19.9307 175.205 21.5626Z",
    fill: "url(#paint18_linear_3997_4413)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M190.705 18.5769V28.5912C190.705 30.2231 189.452 31.5584 187.921 31.5584H187.868L180.542 22.8237V28.5912C180.542 30.2231 179.289 31.5769 177.757 31.5769H177.705V21.5626C177.705 19.9307 178.958 18.5769 180.49 18.5769H180.542L187.868 27.2745V21.5626C187.868 19.9307 189.121 18.5769 190.653 18.5769H190.705Z",
    fill: "url(#paint19_linear_3997_4413)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M196.138 26.5883V31.5769H196.084C194.501 31.5769 193.205 30.2231 193.205 28.5912V18.5769H193.259C194.843 18.5769 196.138 19.9307 196.138 21.5626V23.5655H198.226L203.048 18.5769H207.205L200.799 25.1974L206.989 31.5769H202.832L198.01 26.5883H196.138Z",
    fill: "url(#paint20_linear_3997_4413)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3997_4413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.6253 28.3021) scale(10.7627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0268817,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6855,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7634,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3997_4413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0211 38.7033) scale(5.99527)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0268817,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6855,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7634,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3997_4413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.819 15.4333) scale(3.91417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2347,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3827,
    stopColor: "#9EA0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5714,
    stopColor: "#E6E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7041,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9235,
    stopColor: "#9EA0A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3997_4413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8943 16.2335) scale(1.96325)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71CDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3767,
    stopColor: "#5495C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8044,
    stopColor: "#3965AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3053A5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3997_4413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8793 16.223) scale(1.2446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1874,
    stopColor: "#0D5B66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7454,
    stopColor: "#162C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3997_4413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8875 16.2286) scale(1.05866)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1874,
    stopColor: "#0D5B66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7454,
    stopColor: "#162C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3997_4413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5049 16.9989) scale(1.06704)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1874,
    stopColor: "#0D5B66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7454,
    stopColor: "#162C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3997_4413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9895 25.0768) scale(21.3978)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0268817,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6855,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7634,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3997_4413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8797 24.9461) scale(4.04892)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0268817,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6855,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7634,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3997_4413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7302 14.9451) scale(3.09973)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#9EA0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E6E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#9EA0A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3997_4413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7301 14.9452) scale(3.00286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#0D5B66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#162C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_3997_4413",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7305 14.9451) scale(1.64673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#0D5B66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#12445C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3997_4413",
    x1: 68.276,
    y1: 25.0438,
    x2: 81.0336,
    y2: 25.0656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0268817,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6855,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7634,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3997_4413",
    x1: 83.7504,
    y1: 20.6181,
    x2: 96.8382,
    y2: 25.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0268817,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6855,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7634,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3997_4413",
    x1: 98.6126,
    y1: 21.2837,
    x2: 112.919,
    y2: 25.0656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0268817,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6855,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7634,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3997_4413",
    x1: 115.028,
    y1: 20.6181,
    x2: 128.116,
    y2: 29.4912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0268817,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6855,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7634,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3997_4413",
    x1: 132.774,
    y1: 19.9526,
    x2: 147.415,
    y2: 28.6039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0268817,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6855,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7634,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3997_4413",
    x1: 172.19,
    y1: 7.96024,
    x2: 155.942,
    y2: 8.29712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155093,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389162,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595516,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863638,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3997_4413",
    x1: 175.779,
    y1: 7.96024,
    x2: 172.027,
    y2: 7.97819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155093,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389162,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595516,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863638,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3997_4413",
    x1: 193.19,
    y1: 7.96024,
    x2: 176.942,
    y2: 8.29712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155093,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389162,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595516,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863638,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3997_4413",
    x1: 209.882,
    y1: 7.96024,
    x2: 192.385,
    y2: 8.35091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155093,
    stopColor: "#3EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389162,
    stopColor: "#3594C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595516,
    stopColor: "#2D66AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863638,
    stopColor: "#2B55A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17174A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSidebar);
export default __webpack_public_path__ + "static/media/logo_sidebar.5ea28a76f30b6ac08df22c9efbb248cf.svg";
export { ForwardRef as ReactComponent };